/** Таблица соответствия размера компонента Dt и размера шрифта (размер Dt на шаг меньше, чем Dd) */
export var dtSizesConfig = {
  xxxl: {
    fontVariant: {
      desktop: "xxl",
      notDesktop: "xl"
    }
  },
  xxl: {
    fontVariant: {
      desktop: "xl",
      notDesktop: "l"
    }
  },
  xl: {
    fontVariant: {
      desktop: "l",
      notDesktop: "m"
    }
  },
  l: {
    fontVariant: {
      desktop: "m",
      notDesktop: "s"
    }
  },
  m: {
    fontVariant: {
      desktop: "s",
      notDesktop: "xs"
    }
  },
  s: {
    fontVariant: "xs"
  },
  xs: {
    fontVariant: "xs"
  }
};